import * as React from 'react';
import { SVGProps, memo } from 'react';
const Mobile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1em"
    width="1em"
    viewBox="0 0 384 512"
    {...props}
  >
    <path
      style={{
        opacity: 1,
        fill: '#012059',
        stroke: '#012059',
        strokeWidth: 3.23161912,
        strokeLinecap: 'round',
        strokeMiterlimit: 4,
        fillOpacity: 1,
        strokeOpacity: 1,
      }}
      d="M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z"
    />
  </svg>
);
const Memo = memo(Mobile);
export default Memo;
